var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripeLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.25,
    width: 19,
    height: 20.5833,
    fill: "#012633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6732 19.24C9.64654 19.24 8.73987 19.0667 7.9532 18.72C7.16654 18.36 6.54654 17.8533 6.0932 17.2C5.63987 16.5333 5.40654 15.7267 5.3932 14.78H8.0932C8.11987 15.4333 8.3532 15.9867 8.7932 16.44C9.24654 16.88 9.86654 17.1 10.6532 17.1C11.3332 17.1 11.8732 16.94 12.2732 16.62C12.6732 16.2867 12.8732 15.8467 12.8732 15.3C12.8732 14.7267 12.6932 14.28 12.3332 13.96C11.9865 13.64 11.5199 13.38 10.9332 13.18C10.3465 12.98 9.71987 12.7667 9.0532 12.54C7.9732 12.1667 7.14654 11.6867 6.5732 11.1C6.0132 10.5133 5.7332 9.73333 5.7332 8.76C5.71987 7.93333 5.9132 7.22667 6.3132 6.64C6.72654 6.04 7.28654 5.58 7.9932 5.26C8.69987 4.92667 9.5132 4.76 10.4332 4.76C11.3665 4.76 12.1865 4.92667 12.8932 5.26C13.6132 5.59333 14.1732 6.06 14.5732 6.66C14.9865 7.26 15.2065 7.97333 15.2332 8.8H12.4932C12.4799 8.30667 12.2865 7.87333 11.9132 7.5C11.5532 7.11333 11.0465 6.92 10.3932 6.92C9.8332 6.90667 9.35987 7.04667 8.9732 7.34C8.59987 7.62 8.4132 8.03333 8.4132 8.58C8.4132 9.04667 8.55987 9.42 8.8532 9.7C9.14654 9.96667 9.54654 10.1933 10.0532 10.38C10.5599 10.5667 11.1399 10.7667 11.7932 10.98C12.4865 11.22 13.1199 11.5 13.6932 11.82C14.2665 12.14 14.7265 12.5667 15.0732 13.1C15.4199 13.62 15.5932 14.2933 15.5932 15.12C15.5932 15.8533 15.4065 16.5333 15.0332 17.16C14.6599 17.7867 14.1065 18.2933 13.3732 18.68C12.6399 19.0533 11.7399 19.24 10.6732 19.24Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/StripeLogo.19443bf5601525de8caa0246c2285a95.svg";
export { ForwardRef as ReactComponent };